module.exports = __webpack_public_path__ + "img/Wonder-Women-650x680.ff261456.png";